module.exports = __webpack_public_path__ + "img/active.99721cf7.svg";